import { ConflictData } from './../conflict-history/index.js';

export enum InfoState {
  NotFilled = 'Data has not been added' /* student and import values do not exist */,
  NotFilledImport = 'Data has been imported but not confirmed' /* student value does not exist, import value exists */,
  Manual = 'Data has been imported and manually added' /* student value cant exist, import value exists */,
  NotFilledPassport = 'Data has been used from passport' /* student value does not exist, passport value exists */,
  Filled = 'Data has been entered into CAS Shield' /* student value exists, import value and passport value does not exist */,
  Approved = 'Item has been completed' /* student, import and possible passport values exist, no conflict */,
  Conflict = 'Conflict between imported data and CAS Shield data' /* CONFLICT state */,
  Update = 'Item has been updated since it was imported' /* UPDATE state */,
  Pending = 'Item is pending' /* PENDING state */,
  Resolved = 'Conflict in the data has been resolved' /* resolved CONFLICT/UPDATE */,
  Removed = 'Item has been removed' /* item removed */,
  Skipped = 'Item has been skipped' /* when item have been turned off in config */,
  Optional = 'Item cannot be checked by student' /* shown when item cannot be checked by the student */,
  TransferMate = 'TransferMate Payments',
}

export interface InfoField {
  id: string;
  index?: number;
  label: string;
  subLabel?: string;
  values: {
    import?: string;
    student?: string;
    passport?: string;
  };
  options: Array<InfoOption>;
  state: InfoState;
  editPage?: string;
  addFieldBtn?: InfoAddField;
  multiLine?: boolean;
}

export interface InfoAddField {
  label: string;
  action: string;
}

export interface InfoOption {
  id: string;
  label: string;
  value?: string;
  disabled?: boolean;
  conflictHistory?: string;
  valuePending?: boolean;
  editPage?: string;
}

export interface IConflictFactors {
  hasStudentValue: boolean;
  hasImportValue: boolean;
  hasPassportValue?: boolean;
  studentValue: string | number;
  importValue: string | number;
  passportValue?: string | number;
  conflictHistory?: ConflictData<string | number>;
  allowEmptyValue?: boolean;
}
